// extracted by mini-css-extract-plugin
export default {"container":"EntityMultiSelectField_container__6XUh-"};